import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AttendanceLocalDepartment } from "../../../../@types/attendance-local-department";
import { apisiseci } from "../../../api";
import { AxiosError } from "axios";

export type AttendanceLocalDepartmentUpdateData = {
    ativo: boolean;
    setor_sigla?: string;
    setor_nome?: string;
};

export function useAttendanceLocalDepartmentUpdate(id: AttendanceLocalDepartment["id"]) {
    const queryClient = useQueryClient();

    const mutation = useMutation<
        AttendanceLocalDepartment,
        AxiosError<{ detail: string; }>,
        AttendanceLocalDepartmentUpdateData
    >({
        mutationKey: ["attendance-local", "department", "update", id],
        mutationFn: async (data) => {
            const token = localStorage.getItem("gov_access_token_sso");
            return apisiseci.put(
                `/cms/setor_unidade/${id}/`, data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
        },
        onSuccess: async () => {
            toast.success("Setor atualizado com sucesso!");

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "department", "list"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "department", "details", id],
                })
            ]);
        },
        onError: (error) => {
            console.log(error);
            toast.error(error?.response?.data?.detail || "Algo deu errado, tente novamente!");
        },
    });

    return mutation;
}
